import { render, staticRenderFns } from "./SearchBuild.vue?vue&type=template&id=dd19d1c6&scoped=true"
import script from "./SearchBuild.vue?vue&type=script&lang=js"
export * from "./SearchBuild.vue?vue&type=script&lang=js"
import style0 from "./SearchBuild.vue?vue&type=style&index=0&id=dd19d1c6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd19d1c6",
  null
  
)

export default component.exports